import { h } from 'preact';

const Facebook = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role='img' {...props}>
			<path d="M6.68 14V8.526H4.772V6.393H6.68V4.82C6.68 2.994 7.836 2 9.523 2c.808 0 1.503.058 1.705.084v1.908l-1.17.001c-.918 0-1.095.421-1.095 1.039v1.362h2.188l-.285 2.133H8.962V14H6.68z"/>
		</svg>
	);
};

export default Facebook;
